import React, { useEffect, useState } from "react";
import DataTable, { createTheme } from "react-data-table-component";
import "../../styles/Licences/licences.css";
import "../../styles/globalstyle.css";
// import "../../styles/index.css";
import { EditIcon, DeleteIcon } from "../../assets/SvgIcons";
import {
  assign_licence,
  get_assigned_products_to_user,
  get_product_licenses,
  get_product_licenses_for_user,
  get_products,
  get_users,
  remove_user_assigned_to_product,
  update_assign_licence,
} from "../../api/serverWrapper";
import {
  conditionalRowStyles,
  custombatsmanbowlertableStylesExpandable,
  customtableStyles,
} from "../../assets/tablestyle";
import styled from "styled-components";
import Licenceassign from "./Licenceassign";
import LicenceAssign from "../../componant/Licences/LicenceAssign";
import { getData } from "../../utils/localstorage_constants";
import { USER_DATA } from "../../utils/localstorage_variables";

const Licences = () => {
  let [products, setProducts] = useState();
  let [selectedProduct, setselectedProduct] = useState(0);
  let [isassignlicensevisible, setIsAssignLicenseVisible] = useState(false);
  let [editassignlicense, setEditAssignLicense] = useState(false);

  let [assignlicence, setAssignLicence] = useState(new LicenceAssign());
  let [users, setUsers] = useState();
  let [adminuser, setAdminUser] = useState(null);
  let [assignedproductstouser, setAssignedProductsToUser] = useState([]);
  createTheme("solarized", {
    background: {
      default: "var(--main-background-color)",
    },
  });

  const productscolumn = [
    {
      name: "Product",
      selector: (row) => row?.Product?.Name,
      center: true,
      width: "150px",
    },
  ];

  const usercolumn = [
    {
      name: "Name",
      selector: (row) => row.User.Name,
      center: true,
      // width: "150px",
    },
    {
      name: "Mobile",
      selector: (row) => row.User.PhoneNumber,
      center: true,
      // width: "150px",
    },
    {
      name: "Email",
      selector: (row) => row.User.Email,
      center: true,
      // width: "150px",
    },
    {
      name: "Assigned licenses",
      selector: (row) => row.NoOflicensesAssigned,
      center: true,
      // width: "250px",
    },
    {
      name: "Edit",
      selector: (row) => (
        <img
          style={{ height: "25px", width: "25px", marginRight: "25px" }}
          alt=""
          src={EditIcon}
          onClick={() => handleEditUserLicence(row)}
        />
      ),
      width: "80px",
      headerStyle: () => {
        return {
          textAlign: "right",
        };
      },
    },
    {
      name: "Delete",
      selector: (row) => (
        <img
          style={{ height: "25px", width: "25px" }}
          alt=""
          src={DeleteIcon}
          onClick={() => handleDeleteUserLicence(row)}
        />
      ),
      width: "80px",
    },
  ];

  const assignedproductscolumn = [
    {
      name: "Product",
      selector: (row) => row.License.Product.Name,
      center: true,
      // width: "150px",
    },
    {
      name: "Loged Devices",
      selector: (row) => row?.License?.Product?.LoggedHardwares?.length ?? 0,
      center: true,
      // width: "250px",
    },
    {
      name: "Assigned licenses",
      selector: (row) => row.NoOflicensesAssigned,
      center: true,
      // width: "250px",
    },
    {
      name: "Assigned By",
      selector: (row) => row.License.User.Name,
      center: true,
      // width: "250px",
    },
  ];

  const logeddevicecolumn = [
    {
      name: "sl",
      selector: (row, index) => index + 1,
      center: true,
      width: "150px",
    },
    {
      name: "Device",
      selector: (row) => row.HardwareId,
      center: true,
      width: "150px",
    },
  ];
  useEffect(() => {
    loadData();
  }, []);

  useEffect(() => {
  console.log("Users:", users);
}, [users]);

  const loadData = async () => {
    let userdata = getData(USER_DATA);

    adminuser = userdata;
    setAdminUser(adminuser);
    if (userdata?.IsAdmin) {
      loadUserProducts();
      loadUsers();
    } else {
      loadAssignedProductsToUser();
    }
  };

  const loadUserProducts = async () => {
    let licensespurchased = await get_product_licenses_for_user(adminuser?.id);
    products = licensespurchased.data.licenses;
    setProducts(products);
    selectedProduct = products[0];
    setselectedProduct(selectedProduct);
  };

  const loadUsers = async () => {
    let userresp = await get_users(adminuser?.id);
    users = userresp.data;
    setUsers(users);
  };

  const loadAssignedProductsToUser = async () => {
    let assignedproductresp = await get_assigned_products_to_user(
      adminuser?.id
    );

    assignedproductstouser = assignedproductresp.data;
    setAssignedProductsToUser(assignedproductstouser);
  };

  const NoDataText = styled.div`
    color: var(--text-color); /* Change this to whatever color you want */
    font-size: 16px; /* Customize font size if needed */
    text-align: center;
    padding: 20px;
  `;
  const conditionalRowStylesdis = [
    {
      when: (row) => row.ProductId === selectedProduct?.ProductId,
      style: {
        backgroundColor: "var(--active-border)",
        color: "#fff", // You can adjust this or remove it if needed
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  ];

  const customtableStyles_dt = {
    headRow: {
      style: {
        // borderRadius: "30px",
        // backgroundColor: "var(--table-header)",
        color: "var(--text-color)",
        fontWeight: "bold",
      },
    },

    rows: {
      style: {
        // borderRadius: "30px",
        color: "var(--text-color)",
        height: "60px",
        "&:hover": {
          cursor: "pointer",
        },
      },
    },
  };

  const handleEditUserLicence = async (licencedetails) => {
    assignlicence = new LicenceAssign(licencedetails);
    setAssignLicence(assignlicence);
    editassignlicense = true;
    setEditAssignLicense(editassignlicense);
    isassignlicensevisible = true;
    setIsAssignLicenseVisible(isassignlicensevisible);
  };
  const handleDeleteUserLicence = async (licencedetails) => {
    let resp = await remove_user_assigned_to_product(
      licencedetails.UserId,
      licencedetails.NoOflicensesAssigned,
      licencedetails.ProductId,
      licencedetails.AssignedByUserId
    );
    if (resp.success) {
      alert("User removed");
      loadUserProducts();
    } else {
      alert(resp.message);
    }
  };
  const handleProductSelection = async (product) => {
    setselectedProduct(product);
  };
  const showAssignLicencePopUp = () => {
    isassignlicensevisible = !isassignlicensevisible;
    setIsAssignLicenseVisible(isassignlicensevisible);
    editassignlicense = false;
    setEditAssignLicense(editassignlicense);
  };

  const handleAssignUserDetails = (event) => {
    const { name, value } = event.target;

    let selecteduser = users.find((user) => user.id === Number(value));

    assignlicence.User = selecteduser;
    setAssignLicence(assignlicence);
  };

  const handleProductAssign = (event) => {
    const { name, value } = event.target;
    let selectproduct = products.find(
      (product) => product.ProductId === Number(value)
    );

    assignlicence.ProductId = selectproduct.ProductId;
    assignlicence.id = selectproduct.id;
    setAssignLicence(assignlicence);
  };
  const handleAssignDetails = (event) => {
    const { name, value } = event.target;

    setAssignLicence({ ...assignlicence, [name]: value });
  };

  const handleSubmitAssignLicence = async () => {
    assignlicence.AssignedByUserId = 2;
    setAssignLicence(assignlicence);
    let resp = await assign_licence(assignlicence);
    if (resp.success) {
      alert("Licence Assigned");
      assignlicence = new LicenceAssign(null);
      setAssignLicence(assignlicence);
      showAssignLicencePopUp();
      loadData();
    } else {
      alert(resp.message);
    }
  };
  const handleSubmitEditAssignLicence = async () => {
    delete assignlicence.id;
    setAssignLicence(assignlicence);
    let resp = await update_assign_licence(assignlicence);

    if (resp.success) {
      alert("Licence Updated");
      assignlicence = new LicenceAssign(null);
      setAssignLicence(assignlicence);
      editassignlicense = !editassignlicense;
      setEditAssignLicense(editassignlicense);
      showAssignLicencePopUp();
      loadUserProducts();
    } else {
      alert(resp.message);
    }
  };

  const ExpandedComponent = ({ data }) => {
    return (
      <div className="p-1" style={{ marginLeft: "52px" }}>
        {" "}
        {data.length > 0 ? (
          <DataTable
            className="data-table-expandable-report"
            columns={logeddevicecolumn}
            data={data}
            customStyles={customtableStyles}
            conditionalRowStyles={conditionalRowStyles}
            noHeader
            persistTableHead={false}
            dense
            theme="solarized"
          />
        ) : (
          <div>No details available</div>
        )}
      </div>
    );
  };
  return (
    <div className="licence_container">
      {adminuser?.IsAdmin ? (
        <div className="display_container_row">
          <div className="product_table_container">
            <DataTable
              data={products}
              columns={productscolumn}
              customStyles={customtableStyles_dt}
              conditionalRowStyles={conditionalRowStylesdis}
              fixedHeader
              theme="solarized"
              onRowClicked={(row) => handleProductSelection(row)}
              fixedHeaderScrollHeight="600px"
            />
          </div>

          <div className="license_table_user_container">
            <div className="display_container_row display_align_items_center display_Justify_conten_space_between license_count_assignebtn_container">
              <div className="license_count_container">
                <div>
                  <h1 className="license_summery">Product licenses</h1>
                </div>
                <div className="display_container_row">
                  <div>
                    <div className="display_container_row  display_align_items_center display_Justify_conten_center">
                      <h3>Total Licenses Purchased</h3>
                      <h5> : </h5>
                      <h4>{selectedProduct?.NoOfLicensesPurchased ?? 0}</h4>
                    </div>
                    <div className="display_container_row  display_align_items_center display_Justify_conten_center">
                      <h3>Licenses assigned to users</h3>
                      <h5> : </h5>
                      <h4>{selectedProduct?.NoOfLicensesAssigned ?? 0}</h4>
                    </div>
                  </div>
                  <div>
                    <div className="display_container_row   display_align_items_center">
                      <h3>Licenses are in use</h3>
                      <h5> : </h5>

                      <h4>{selectedProduct?.NoOfLicensesInUse ?? 0}</h4>
                    </div>
                    <div className="display_container_row  display_align_items_center">
                      <h3>Licenses not assigned</h3>
                      <h5> : </h5>

                      <h4>
                        {(selectedProduct?.NoOfLicensesPurchased ?? 0) -
                          (selectedProduct?.NoOfLicensesAssigned ?? 0)}
                      </h4>
                    </div>
                  </div>
                </div>
              </div>
              <button className="btn" onClick={() => showAssignLicencePopUp()}>
                Assign license
              </button>
            </div>

            <div className="product_License_user_list">
              <DataTable
                data={selectedProduct?.Product?.ProductLicenseAssigned}
                columns={usercolumn}
                customStyles={customtableStyles}
                conditionalRowStyles={conditionalRowStyles}
                fixedHeader
                theme="solarized"
                // onRowClicked={(row) => handleProductSelection(row)}
                fixedHeaderScrollHeight="600px"
              />
            </div>
          </div>
        </div>
      ) : (
        <div className="product_License_user_list">
          <DataTable
            data={assignedproductstouser}
            columns={assignedproductscolumn}
            customStyles={customtableStyles}
            conditionalRowStyles={conditionalRowStyles}
            fixedHeader
            expandableRows
            expandableRowsComponent={({ data }) => (
              <ExpandedComponent data={data.License.Product.LoggedHardwares} />
            )}
            theme="solarized"
            fixedHeaderScrollHeight="600px"
            noDataComponent={<NoDataText>No records found</NoDataText>}
          />
        </div>
      )}
      {isassignlicensevisible && (
        <Licenceassign
          handleAssignDetails={handleAssignDetails}
          handleAssignUserDetails={handleAssignUserDetails}
          handleSubmitAssignLicence={handleSubmitAssignLicence}
          handleProductAssign={handleProductAssign}
          showAssignLicencePopUp={showAssignLicencePopUp}
          users={users}
          products={products}
          editassignlicense={editassignlicense}
          assignlicence={assignlicence}
          handleSubmitEditAssignLicence={handleSubmitEditAssignLicence}
        />
      )}
    </div>
  );
};

export default Licences;
